import { Mode, plugin, useTranslation } from '@common';
import { WidgetType } from '../types';
import { Thumbnail } from '../../component';
import { ShotEyesUserDesignMode } from './design';
import { ShotEyesUserInputMode } from './input';
import { ShotEyesUserViewMode } from './view';
import type { ReactElement } from 'react';
import type { ShotEyesUserProps } from './types';

// 奖罚配单-用户
export function PenaltiesUser(props: ShotEyesUserProps): ReactElement | null {
  const [t] = useTranslation();

  if (props.mode === Mode.THUMBNAIL) {
    return (<Thumbnail
      icon='ShotEyesUserIcon'
      title={t('ShotEyesUser')}
      toolTipContent={t('填写员工信息')} />);
  }

  if (props.mode === Mode.DESIGN) {
    return (<ShotEyesUserDesignMode {...props} />);
  }

  if (props.mode === Mode.VIEW) {
    return (<ShotEyesUserViewMode {...props} />);
  }

  if (props.mode === Mode.INPUT) {
    return (<ShotEyesUserInputMode {...props} />);
  }

  return null;
}

PenaltiesUser.prototype.type = WidgetType.SHOTEYES_USER;
plugin.register({ kind: 'widget', component: PenaltiesUser });
